// Zod-free leaf module: plain enum + constant, no imports, so lean bundles
// (POS) can use these values without loading draft-return-items.ts zod schemas.

export enum PriceDifference {
  IGNORE = "ignore",
  APPLY = "apply",
}

export const DEFAULT_VARIANT_TITLE = "Default Title";
